import { useMode } from '../../contexts/ModeContext.js';

const ROLE_LABEL: Record<string, string> = {
  manager:    'Manager',
  programmer: 'Programmer',
  operator:   'Operator',
};

export function ImpersonationBanner(): JSX.Element | null {
  const { impersonation, stopImpersonating } = useMode();
  if (!impersonation) return null;

  return (
    <div
      className="sticky top-0 z-20 flex items-center justify-between px-4 py-2 text-xs font-mono"
      style={{
        backgroundColor: 'rgba(255, 180, 0, 0.12)',
        borderBottom: '1px solid rgba(255, 180, 0, 0.3)',
        color: '#f5a623',
      }}
    >
      <span>
        Viewing as <strong>{impersonation.userId}</strong>{' '}
        <span style={{ opacity: 0.7 }}>
          ({ROLE_LABEL[impersonation.role] ?? impersonation.role})
        </span>
        {impersonation.assignedMachineIds && (
          <span style={{ opacity: 0.7 }}>
            {' '}· {impersonation.assignedMachineIds.size} machine
            {impersonation.assignedMachineIds.size !== 1 ? 's' : ''}
          </span>
        )}
      </span>
      <button
        type="button"
        onClick={stopImpersonating}
        className="ml-4 px-2 py-0.5 rounded border text-[11px] hover:bg-yellow/10 transition-colors"
        style={{ borderColor: 'rgba(255, 180, 0, 0.4)' }}
      >
        Exit view
      </button>
    </div>
  );
}
